/// <reference path="../../public/jquery-1.6.2.min.js" />
/// <reference path="../../public/General.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('ScheduleView.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    throw ('ScheduleView.js requies the sumo.controls namespace defined in ControlBase.js');
}

// options
//  cssClass
//  cssStandardScheduleItemClass
//  cssOverrideScheduleItemClass
//  cssSelectedScheduleItemClass

// schedule definitions
//  id
//  type - override, standard (default)
//  startSunday
//  startMonday
//  startTuesday
//  startWednesday
//  startThursday
//  startFriday
//  startSaturday
//  startTime
//  endTime - if end time < start time, then break to two schedule items. one start time to midnight and one midnight to end time the following day
//  hoverText
/**
 * @class
 * @param  {} aId
 * @param  {} aParentId
 * @param  {} aOptions
 * dataField [ ]
 * @example
 * mEnrolleesControls.SchedulesListView = new sumo.controls.ListView('uEnrolleesSchedulesListView', 'uEnrolleesSchedulesListViewHolder', {
        'keyField': 'Id', 'selectMethod': 'ctrlKey', 'cssClass': 'VeritracksListView', 'canUnselect': true, 'localization': true
    }, [
            { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'Target', 'title': localizeWrapper('cEnrolleeScheduleTarget'), 'dataField': 'TargetName', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'TargetType', 'title': localizeWrapper('cEnrolleeScheduleTargetType'), 'dataField': 'TargetTypeName', 'width': 'autoData', 'minWidth': 75, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'StartTimeLocal', 'title': localizeWrapper('cAnalysisStart'), 'dataField': 'StartTimeLocal', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': getTimeFormatter },
            { 'id': 'EndTimeLocal', 'title': localizeWrapper('cAnalysisEnd'), 'dataField': 'EndTimeLocal', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': getTimeFormatter },
            { 'id': 'ScheduleType', 'title': localizeWrapper('cEnrolleeScheduleType'), 'dataField': 'ScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'ZoneScheduleType', 'title': localizeWrapper('cEnrolleeZoneScheduleType'), 'dataField': 'ZoneScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': scheduleZoneTypeFormatter },
            { 'id': 'IsSunday', 'title': localizeWrapper('cSundayLetter'), 'dataField': 'IsSunday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsMonday', 'title': localizeWrapper('cMondayLetter'), 'dataField': 'IsMonday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsTuesday', 'title': localizeWrapper('cTuesdayLetter'), 'dataField': 'IsTuesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsWednesday', 'title': localizeWrapper('cWednesdayLetter'), 'dataField': 'IsWednesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsThursday', 'title': localizeWrapper('cThursdayLetter'), 'dataField': 'IsThursday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsFriday', 'title': localizeWrapper('cFridayLetter'), 'dataField': 'IsFriday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsSaturday', 'title': localizeWrapper('cSaturdayLetter'), 'dataField': 'IsSaturday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false }
    ]);
    mEnrolleesControls.SchedulesListView.bind('selectedchanged', uEnrolleesSchedulesListView_OnSelectChange, null);
    mEnrolleesControls.SchedulesListView.bind('update', uEnrolleesSchedulesListView_Update);
    mEnrolleesControls.SchedulesListView.bind('sort', uEnrolleesSchedulesListView_OnSort);
 * 
 */
sumo.controls.ScheduleView = function (aId, aParentId, aOptions) {
    "use strict";

    sumo.controls.ScheduleView.prototype.baseClass.call(this, aId, aParentId,
        '<div class="sumo-scheduleview-control" id="##id##" style="height: 100%; overflow: hidden;"></div>',
        aOptions);

    var mThis = this,
        mSelectedKey = null,
        mDataSource = null,
        mCurrentDataSource = null,
        mIsDirty = false,
        mDays = ['S', 'M', 'T', 'W', 'R', 'F', 'S'],
        mStartDate = new Date(),
        mEndDate = new Date(),

    // options
    mCssClass = null,

    // html/jquery elements
        mViewPort = null,
        mDate = null,
        mHeader = null,
        mTable = null,
        mRows = null,
        mCells = null,
        mBody = null;

    if (!this.isNothing(aOptions)) {
        if (!this.isNothing(aOptions.cssClass)) {
            mCssClass = aOptions.cssClass;
        }
    }

    function getHeaderContent() {
        var i = 0,
            lDay = '<div style="padding-right:5px; padding-left:5px; overflow: hidden;">&nbsp;</div>',
            lHtml = [];
        for (i = 0; i < 9; i++) {
            lHtml.push('<th class="');
            lHtml.push('sumo-scheduleview-static-header ');
            lHtml.push('sumo-scheduleview-header-cell" style="border-right:1px solid white"><div ');
            if (i === 1) {
                lDay = '<div style="overflow: hidden;">&nbsp;</div>';
            } else if (i > 1) {
                lDay = '<div style="overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;">' + mDays[i - 2] + '</div>';
            }
            lHtml.push(' id="');
            lHtml.push(mThis.Id);
            lHtml.push(i.toString());
            lHtml.push('" class="');
            lHtml.push(mThis.Id);
            lHtml.push(i.toString());
            lHtml.push('-header">');
            lHtml.push(lDay);
            lHtml.push('</div></th>');
        }
        return lHtml.join('');
    }

    function getScheduleDivs(aDayIndex, aHourIndex, aMinuteIndex) {
        var lWidth,
            lAddScheduleDiv,
            lIsFlipped,
            lLeftMargin,
            lScheduleKey,
            lSchedule,
            lStartScheduleHour,
            lStartScheduleMinute,
            lEndScheduleHour,
            lEndScheduleMinute,
            lMidnightTomorrow = new Date(),
            lCurrentTime = new Date(),
            lCurrentTimeTomorrow = new Date(),
            lStartScheduleDate,
            lEndScheduleDate,
            lResult = '';

        lCurrentTime.setHours(aHourIndex, aMinuteIndex, 0, 0);
        lCurrentTimeTomorrow.addDays(1);
        lCurrentTimeTomorrow.setHours(aHourIndex, aMinuteIndex, 0, 0);
        lMidnightTomorrow.addDays(1);
        lMidnightTomorrow.setHours(0, 0, 0, 0);

        lWidth = 21;
        for (lScheduleKey in mCurrentDataSource) {
            if (mCurrentDataSource.hasOwnProperty(lScheduleKey)) {
                lStartScheduleDate = new Date();
                lEndScheduleDate = new Date();

                lLeftMargin = '';

                lSchedule = mCurrentDataSource[lScheduleKey];
                lIsFlipped = (lSchedule.type === 'reoccurring' && lSchedule.startTime >= lSchedule.endTime) ||
                             ((lSchedule.type === 'override' || lSchedule.startTime.getDay() !== lSchedule.endTime.getDay()) &&
                                 (lSchedule.startTime.getHours() * 60 + lSchedule.startTime.getMinutes()) >=
                                    (lSchedule.endTime.getHours() * 60 + lSchedule.endTime.getMinutes()));

                if (lSchedule.type === 'reoccurring') {
                    lStartScheduleHour = lSchedule.startTime.getHours();
                    lStartScheduleMinute = lSchedule.startTime.getMinutes();
                    if (lStartScheduleMinute > 52) {
                        lStartScheduleHour += 1;
                        lStartScheduleMinute = 0;
                    } else {
                        lStartScheduleMinute = (Math.round(lStartScheduleMinute / 15) * 15) % 60;
                    }

                    lEndScheduleHour = lSchedule.endTime.getHours();
                    lEndScheduleMinute = lSchedule.endTime.getMinutes();
                    if (lEndScheduleMinute > 52) {
                        lEndScheduleHour += 1;
                        lEndScheduleMinute = 0;
                    } else {
                        lEndScheduleMinute = (Math.round(lEndScheduleMinute / 15) * 15) % 60;
                    }

                    lStartScheduleDate.setHours(lStartScheduleHour, lStartScheduleMinute, 0, 0);
                    lEndScheduleDate.setHours(lEndScheduleHour, lEndScheduleMinute, 0, 0);
                    if (lIsFlipped) {
                        lEndScheduleDate.addDays(1);
                    }
                } else {
                    lStartScheduleDate.setHours(lSchedule.startTime.getHours(), lSchedule.startTime.getMinutes(), 0, 0);
                    lEndScheduleDate.setHours(lSchedule.endTime.getHours(), lSchedule.endTime.getMinutes(), 0, 0);
                    if (lIsFlipped) {
                        lEndScheduleDate.addDays(1);
                    }
                }
                lAddScheduleDiv = false;
                if (!lIsFlipped && (lStartScheduleDate <= lCurrentTime) && (lCurrentTime < lEndScheduleDate)) {
                    if ((lSchedule.startSunday && aDayIndex === 0) ||
                        (lSchedule.startMonday && aDayIndex === 1) ||
                        (lSchedule.startTuesday && aDayIndex === 2) ||
                        (lSchedule.startWednesday && aDayIndex === 3) ||
                        (lSchedule.startThursday && aDayIndex === 4) ||
                        (lSchedule.startFriday && aDayIndex === 5) ||
                        (lSchedule.startSaturday && aDayIndex === 6)) {
                        lAddScheduleDiv = true;
                    }
                } else if (lIsFlipped) {
                    if (lStartScheduleDate <= lCurrentTime && lCurrentTime <= lMidnightTomorrow) {
                        if ((lSchedule.startSunday && aDayIndex === 0) ||
                        (lSchedule.startMonday && aDayIndex === 1) ||
                        (lSchedule.startTuesday && aDayIndex === 2) ||
                        (lSchedule.startWednesday && aDayIndex === 3) ||
                        (lSchedule.startThursday && aDayIndex === 4) ||
                        (lSchedule.startFriday && aDayIndex === 5) ||
                        (lSchedule.startSaturday && aDayIndex === 6)) {
                            lAddScheduleDiv = true;
                        }
                    } else if (lEndScheduleDate > lCurrentTimeTomorrow && lCurrentTimeTomorrow >= lMidnightTomorrow) {
                        if ((lSchedule.startSunday && aDayIndex === 1) ||
                        (lSchedule.startMonday && aDayIndex === 2) ||
                        (lSchedule.startTuesday && aDayIndex === 3) ||
                        (lSchedule.startWednesday && aDayIndex === 4) ||
                        (lSchedule.startThursday && aDayIndex === 5) ||
                        (lSchedule.startFriday && aDayIndex === 6) ||
                        (lSchedule.startSaturday && aDayIndex === 0)) {
                            lAddScheduleDiv = true;
                        }
                    }
                }
                if (lAddScheduleDiv) {
                    if (lResult !== '' && lWidth !== 10) {
                        lWidth = 10;
                        lLeftMargin = 'margin-left:1px';
                    }
                    lResult += '<div id="' + mThis.Id + '-scheduleview-itemid-' + lSchedule.id.toString() +
                        '" title="' + lSchedule.hoverText + ': ' + lSchedule.type +
                        '" class="scheduleview-item scheduleview-itemtype-' + lSchedule.type +
                        '" style="width:##width##px;float:left;' + lLeftMargin + '">&nbsp;</div>';
                }
            }
        }
        while (lResult.indexOf('##width##') !== -1) {
            lResult = lResult.replace('##width##', lWidth.toString());
        }
        return lResult;
    }

    function getBodyContent() {
        var lDayIndex,
            lHourIndex,
            lMinuteIndex,
            lHour = '',
            lMinute = '',
            lHtml = [];

        lHtml.push('<tr><td colspan="9"><div style="height:6px;"></div></td></tr>');
        for (lHourIndex = 0; lHourIndex < 24; lHourIndex++) {
            for (lMinuteIndex = 0; lMinuteIndex < 60; lMinuteIndex += 15) {
                lHtml.push('<tr>');
                lHtml.push('<td>');
                if (lHourIndex === 0 && lMinuteIndex === 0) {
                    lHour = '00:00';
                    lHtml.push('<div style="position:relative; top:-8px; padding-right:5px; padding-left:5px; z-index:999" class="');
                    lHtml.push(mThis.Id);
                    lHtml.push('0-data">');
                    lHtml.push(lHour);
                    lHtml.push('</div>');
                } else if (lMinuteIndex === 0 || lMinuteIndex === 30) {
                    lHour = lHourIndex.toString();
                    if (lHour.length === 1) {
                        lHour = '0' + lHour;
                    }
                    lMinute = lMinuteIndex.toString();
                    if (lMinute.length === 1) {
                        lMinute = '0' + lMinute;
                    }
                    lHour += ':' + lMinute;
                    lHtml.push('<div style="position:relative; top:-8px; padding-right:5px; padding-left:5px" class="');
                    lHtml.push(mThis.Id);
                    lHtml.push('0-data">');
                    lHtml.push(lHour);
                    lHtml.push('</div>');
                }
                lHtml.push('</td>');
                lHtml.push('<td style="border-top:1px solid gray;');
                if (lHourIndex === 23 && lMinuteIndex == 45) {
                    lHtml.push('border-bottom:1px solid silver;');
                }
                lHtml.push(' overflow: hidden; border-right: 1px solid gray">');
                lHtml.push('<div style="height:15px; max-height:15px; width:5px;" class="');
                lHtml.push(mThis.Id);
                lHtml.push('1-data">&nbsp;</div>');
                lHtml.push('</td>');
                for (lDayIndex = 0; lDayIndex < 7; lDayIndex++) {
                    // cell
                    lHtml.push('<td style="border-top:1px solid gray;');
                    if (lHourIndex === 23 && lMinuteIndex == 45) {
                        lHtml.push('border-bottom:1px solid gray;');
                    }
                    lHtml.push(' overflow: hidden; border-right: 1px solid gray">');
                    lHtml.push('<div style="height:15px; max-height:15px; min-width:20px;" class="');
                    lHtml.push(mThis.Id);
                    lHtml.push('-day-');
                    lHtml.push(lDayIndex.toString());
                    lHtml.push('-data">');
                    lHtml.push(getScheduleDivs(lDayIndex, lHourIndex, lMinuteIndex));
                    lHtml.push('</div>');
                    lHtml.push('</td>');
                }
                lHtml.push('</tr>');
            }
        }
        return lHtml.join('');
    }

    function selectSchedule(aScheduleId) {
        var lItems = mBody.find('#' + mThis.Id + '-scheduleview-itemid-' + aScheduleId);
        lItems.addClass('scheduleview-selected');
        if (lItems.length > 0) {
            lItems[0].scrollIntoView(false);
        }
    }

    function unselectSchedule(aScheduleId) {
        mBody.find('#' + mThis.Id + '-scheduleview-itemid-' + aScheduleId).removeClass('scheduleview-selected');
    }

    function unselectAll() {
        mBody.find('.scheduleview-item').removeClass('scheduleview-selected');
        mSelectedKey = null;
    }

    function selectSingle(aScheduleId) {
        unselectAll(mSelectedKey);
        selectSchedule(aScheduleId);
        mSelectedKey = aScheduleId;
    }

    function select(aScheduleId) {
        if (!mThis.isNothing(aScheduleId)) {
            mThis.trigger('selectedchanging', mSelectedKey);
            selectSingle(aScheduleId);
            mThis.trigger('selectedchanged', mSelectedKey);
        }
    }

    this.selected = function (aScheduleId) {
        var lResult = null;
        if (this.isNothing(aScheduleId)) {
            lResult = mSelectedKey;
        } else {
            select(aScheduleId);
        }
        return lResult;
    };

    function resizeViewPort() {
        if (mViewPort !== null) {
            mThis.ControlElement.height(mThis.ParentElement.innerHeight());
            mViewPort.height(mThis.ControlElement.innerHeight() - (mHeader.height() + mDate.height()));
        }
    }

    this.resize = function () {
        resizeViewPort();
    };

    function resizeColumns() {
        var i = null;
        for (i = 0; i < 2; i++) {
            $('div.' + mThis.Id + i.toString() + '-header').innerWidth($('div.' + mThis.Id + i.toString() + '-data').innerWidth());
        }
        for (i = 0; i < 7; i++) {
            $('div.' + mThis.Id + (i + 2).toString() + '-header').innerWidth($('div.' + mThis.Id + '-day-' + i.toString() + '-data').innerWidth());
        }
    }

    this.resizeColumns = function () {
        resizeColumns();
    };

    function dataBind() {
        var lHtml = [];

        if (mIsDirty && !mThis.isNothing(mDataSource)) {
            lHtml.push('<div class="sumo-scheduleview-date" id="');
            lHtml.push(mThis.Id);
            lHtml.push('Date"><table><tr><td><div class="Clickable LeftArrowIcon" id="');
            lHtml.push(mThis.Id);
            lHtml.push('Left"></div></td><td>');
            lHtml.push(mStartDate.toDateString());
            lHtml.push(' - ');
            lHtml.push(mEndDate.toDateString());
            lHtml.push('</td><td><div class="Clickable RightArrowIcon" id="');
            lHtml.push(mThis.Id);
            lHtml.push('Right"></div></td></tr></table></div>');
            lHtml.push('<div class="sumo-scheduleview-header"><table class="sumo-scheduleview-header-table" id="');
            lHtml.push(mThis.Id);
            lHtml.push('Header" style="position: relative;" border="0" cellspacing="0" cellpadding="0">');
            lHtml.push('<thead>');
            lHtml.push('<tr class="sumo-scheduleview-header-row">');
            lHtml.push(getHeaderContent());
            lHtml.push('</tr>');
            lHtml.push('</thead>');
            lHtml.push('</table></div>');
            lHtml.push('<div id="');
            lHtml.push(mThis.Id);
            lHtml.push('ViewPort" class="sumo-scheduleview-viewport" style="height: 0px; overflow: auto;">');
            lHtml.push('<table id="');
            lHtml.push(mThis.Id);
            lHtml.push('Table" class="sumo-scheduleview-data-table" cellspacing="0" cellpadding="0" border="0"><tbody id="');
            lHtml.push(mThis.Id);
            lHtml.push('Body">');
            lHtml.push(getBodyContent());
            lHtml.push('</tbody></table>');
            // lHtml.push('<table class="sumo-scheduleview-footer" id="' + mThis.Id + 'Footer" style="position: relative;" cellspacing="0" cellpadding="0">');
            lHtml.push('</div>');

            mThis.ControlElement.html(lHtml.join(''));

            mViewPort = mThis.ControlElement.find('#' + mThis.Id + 'ViewPort');
            mDate = mThis.ControlElement.find('#' + mThis.Id + 'Date');
            mHeader = mThis.ControlElement.find('#' + mThis.Id + 'Header');
            mTable = mThis.ControlElement.find('#' + mThis.Id + 'Table');
            mBody = mTable.find('#' + mThis.Id + 'Body');
            mRows = mBody.find('tr');
            mCells = mBody.find('td');

            $('#' + mThis.Id + 'Left').click(function () { changeStartDate(-1); });
            $('#' + mThis.Id + 'Right').click(function () { changeStartDate(1); });
            if (!mThis.isNothing(mSelectedKey)) {
                select(mSelectedKey, false);
            }

            resizeViewPort();
            resizeColumns();

            mIsDirty = false;

            mThis.trigger('databind');
        }
    }

    function setCurrentDataSource() {
        var lBuilder = new SumoPredicateBuilder(),
            lData = mDataSource;

        lBuilder.AddNewExpressionConditional('startTime', mEndDate, false, mRelationalOperatorEnum.LessThan(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('endTime', mStartDate, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());

        lBuilder.AddNewExpressionConditional('type', 'reoccurring', false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
        lData = query(lData, lBuilder.RootExpression);

        mIsDirty = true;
        mCurrentDataSource = lData;
    }

    function changeStartDate(aDirection) {
        mStartDate.addDays(7 * aDirection);
        mEndDate = new Date(mStartDate);
        mEndDate.addDays(6);
        mEndDate.setHours(23, 59, 59, 999);
        setCurrentDataSource();
        dataBind();
    }

    this.setDataSource = function (aDataSource) {
        mDataSource = aDataSource;
        if (!this.isNothing(mDataSource)) {
            mStartDate = new Date();
            mStartDate.addDays(0 - (mStartDate.getDay()));
            mStartDate.setHours(0, 0, 0, 0);
            mEndDate = new Date(mStartDate);
            mEndDate.addDays(6);
            mEndDate.setHours(23, 59, 59, 999);
            setCurrentDataSource();
            dataBind();
        }
    };

    this.getDataSource = function () {
        return mDataSource;
    };

    this.show = function () {
        if (mIsDirty) {
            dataBind();
        }
        sumo.controls.ScheduleView.prototype.show.call(this);
    };

    function window_OnResize(e) {
        resizeViewPort();
    }

    this.dispose = function () {
        mSelectedKey = null;
        //mViewIndex = null;
        //mDataIndex = null;
        mDataSource = null;
        mCurrentDataSource = null;
        mIsDirty = false;
        //mKeyField = null;
        mCssClass = null;
        //mCssStandardScheduleItemClass = null;
        //mCssOverrideScheduleItemClass = null;
        //mCssSelectedScheduleItemClass = null;
        mViewPort = null;
        mDate = null;
        mHeader = null;
        mTable = null;
        mRows = null;
        mCells = null;
        mBody = null;

        mThis = null;

        sumo.controls.ScheduleView.prototype.dispose.call(this);
    };

    this.render = function () {
        if (!this.isNothing(mCssClass)) {
            this.ControlElement.addClass(mCssClass);
        }
        $(window).resize(window_OnResize);
        this.trigger('render');
    };

    this.render();
};
sumo.controls.ScheduleView.prototype = new sumo.controls.ControlBase();
sumo.controls.ScheduleView.prototype.constructor = sumo.controls.ScheduleView;
sumo.controls.ScheduleView.prototype.baseClass = sumo.controls.ControlBase;